import { Box, Typography } from "@mui/material";
const Benefits = () => {

  return (
    <Box
      sx={{
        overflow: "hidden",
        backgroundColor: '#0e0e0e',
        p: { xs: '50px 20px', sm: '64px 40px', md: '112px 64px' },
      }}
    >
      <Typography
        component='h1'
        sx={{
          color: 'white',
          fontSize: { xs: '3.6rem', sm: '4.2rem', md: '4.8rem' },
          textAlign: 'center',
          fontWeight: '700',
          m: '0rem auto 4rem',
        }}>
        Benefits
      </Typography>

      <Box sx={{
        display: "flex",
        flexDirection: { xs: 'column', sm: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: 'center',
        width: 'fit-content',
        margin: '0 auto',
        borderRadius: '25px',
        p: { xs: '1rem 4rem', md: '3rem 7rem' },
        gap: { xs: '5rem', sm: '10rem' },
      }}>

        <Box
          sx={{
            zIndex: 0,
            opacity: 1,
            width: { xs: "100%", md: '500px', },
            display: 'flex',
            justifyContent: { xs: 'center', md: 'flex-start' },
            height: '500px',
            borderRadius: '25px',
            overflow: 'hidden',
            backgroundImage: `url(${require('../assets/images/SpitEV_on_the_sand.png')})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'top',
          }}
        ></Box>

        <Box sx={{}}>
          <Box
            component="ul"
            sx={{
              display: "flex",
              gap: "4rem",
              flexDirection: "column",
              width: "100%",
              p: "0 1.5rem",
              listStyleType: "",
              listStyleImage: "url('/long-star.svg')",
              " > *": {
                maxWidth: "55ch",
                textAlign: "left",
                color: '#FEFFFACC',
              },
            }}

          >
            <Box component="li" sx={{
              paddingLeft: { xs: '0', md: '1.2rem' }
            }}>
              <Typography
                sx={{
                  color: "#fff",
                  fontSize: '2.4rem',
                  fontWeight: 700,
                  lineHeight: { xs: '2.8rem', md: '2.4rem' },
                  marginBottom: '1rem',
                }}
              >
                Available 24/7
              </Typography>

              <Typography
                sx={{
                  color: "#FEFFFACC",
                  fontSize: '1.5rem',
                  fontWeight: 400,
                  lineHeight: '2rem',
                }}
              >
                Access a nationwide network of private and public chargers reliable, available, and secure.
              </Typography>
            </Box>

            <Box component="li" sx={{
              paddingLeft: { xs: '0', md: '1.2rem' }
            }}>
              <Typography
                sx={{
                  color: "#fff",
                  fontSize: '2.4rem',
                  fontWeight: 700,
                  lineHeight: { xs: '2.8rem', md: '2.4rem' },
                  marginBottom: '1rem',
                }}
              >
                Transparent pricing
              </Typography>

              <Typography
                sx={{
                  color: "#FEFFFACC",
                  fontSize: '1.5rem',
                  fontWeight: 400,
                  lineHeight: '2rem',
                }}
              >
                No surge rates, no hidden fees just simple plans that fit your routine.
              </Typography>
            </Box>

            <Box component="li" sx={{
              paddingLeft: { xs: '0', md: '1.2rem' }
            }}>
              <Typography
                sx={{
                  color: "#fff",
                  fontSize: '2.4rem',
                  fontWeight: 700,
                  lineHeight: { xs: '2.8rem', md: '2.4rem' },
                  marginBottom: '1rem',
                }}
              >
                Real savings
              </Typography>

              <Typography
                sx={{
                  color: "#FEFFFACC",
                  fontSize: '1.5rem',
                  fontWeight: 400,
                  lineHeight: '2rem',
                }}
              >
                Save up to $1200 per year compared to traditional public charging.
              </Typography>
            </Box>

            <Box component="li" sx={{
              paddingLeft: { xs: '0', md: '1.2rem' }
            }}>
              <Typography
                sx={{
                  color: "#fff",
                  fontSize: '2.4rem',
                  fontWeight: 700,
                  lineHeight: { xs: '2.8rem', md: '2.4rem' },
                  marginBottom: '1rem',
                }}
              >
                Earn while you charge
              </Typography>

              <Typography
                sx={{
                  color: "#FEFFFACC",
                  fontSize: '1.5rem',
                  fontWeight: 400,
                  lineHeight: '2rem',
                }}
              >
                Host a charger and earn up to $600 per month, with top-demand areas reaching $2,200.
              </Typography>
            </Box>

            <Box component="li" sx={{
              paddingLeft: { xs: '0', md: '1.2rem' }
            }}>
              <Typography
                sx={{
                  color: "#fff",
                  fontSize: '2.4rem',
                  fontWeight: 700,
                  lineHeight: { xs: '2.8rem', md: '2.4rem' },
                  marginBottom: '1rem',
                }}
              >
                Seamless payouts
              </Typography>

              <Typography
                sx={{
                  color: "#FEFFFACC",
                  fontSize: '1.5rem',
                  fontWeight: 400,
                  lineHeight: '2rem',
                }}
              >
                Automated monthly deposits and complete transparency in your dashboard.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box >
  );
};

export default Benefits;
